import React from 'react';
import { Box } from '@mui/material';
import { FileAlertsProps } from 'components/Documents/components/alerts/FileAlerts.props';
import UploadedFileAlert from 'components/Documents/components/alerts/UploadedFileAlert';

const FileAlerts = ({
  droppedFiles,
  selectedMeasurementDateId,
  validFileTypes,
  fromReferenceWidget,
  setIsFileUploaded,
  setFilesToSave,
}: FileAlertsProps) => {
  const uploadedFileAlertProps = {
    droppedFiles,
    selectedMeasurementDateId,
    validFileTypes,
    fromReferenceWidget,
    setIsFileUploaded,
    setFilesToSave,
  };

  return (
    <div>
      {droppedFiles?.map(file => (
        <div key={file.lastModified}>
          <Box style={{ marginBottom: '1rem' }}>
            <UploadedFileAlert {...uploadedFileAlertProps} file={file} />
          </Box>
        </div>
      ))}
    </div>
  );
};

export default FileAlerts;
